import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../css/login.css';
import useLogin from '../hooks/useLogin';
import { useForm } from "react-hook-form";
import toast, { Toaster } from "react-hot-toast"
import Cookies from 'js-cookie';


function SuperAdminLogin() {

  const { login, error, isLoading } = useLogin()
  const navigate = useNavigate()

 

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    const { loginId, password } = data;

    await login(loginId, password);
  };

  return (
    <>
      <div className='login'>
        <div>
          <h1>Immuniso</h1>
          <h3>Super Admin Login</h3>
        </div>

        <form onSubmit={handleSubmit(onSubmit)}>
          <label htmlFor="login-id"><b>Login Id</b></label>
          <input
            type="email"
            placeholder='Enter email id'
            {...register("loginId", {
              required: "Email is required",
              pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: "Enter a valid email address",
              },
            })}
          />
          {errors.loginId && <p className="error-message">{errors.loginId.message}</p>}

          <label htmlFor="password"><b>Password</b></label>
          <input
            type="password"
            placeholder='Enter password'
            {...register("password", {
              required: "Password is required"
            })}
          />
          {errors.password && <p className="error-message">{errors.password.message}</p>}


          <button disabled={isLoading} className="lrBtn" type="submit">{isLoading ? "Loading..." : "Login"}</button>
          <Link to="">Forget Password?</Link>
        </form>
      </div>
      <Toaster
        position="top-center"
        reverseOrder={false}
        gutter={8}
        containerClassName=""
        containerStyle={{}}
        toastOptions={{
          className: "custom-toast",
          duration: 2000,
          style: {
            background: "#fff",
            color: "#363636",
            fontSize: "14px",
            width: "300px",
            top: "55px !important",
          },
        }}
      />
    </>
  );
}

export default SuperAdminLogin;
